<div class="task-card-block" *ngIf="recordData && recordData?.type === 'type-1'" [ngClass]="recordData?.classes">
	<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
		<div class="main-content" fxFlex="1 0 auto">
			<div class="task-card-chip sub-txt-patch" *ngIf="recordData?.status">
				{{recordData?.status}}
			</div>
			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px"
				*ngIf="recordData?.thumbnail || recordData?.title">
				<div class="thumbnail">
					<img fxLayoutAlign.xs="center center" *ngIf="recordData?.thumbnail" [src]="recordData?.thumbnail" alt="">
				</div>
				<div *ngIf="recordData?.title" fxFlex="1 1">
					<p class="entity-title">{{recordData?.title}}</p>
				</div>
			</div>
			<div class="progress-details"
				*ngIf="recordData?.progressInfo && recordData?.progressInfo?.hasOwnProperty('value')">
				<mat-progress-bar class="progress-br" color="primary" mode="determinate"
					[value]="recordData?.progressInfo?.value">
				</mat-progress-bar>
				<div class="progress-flow" *ngIf="recordData?.progressInfo?.hint">{{recordData?.progressInfo?.hint}}
				</div>
			</div>
			<ng-container *ngIf="![null,undefined].includes(recordData?.content)">
				<div class="task-card-content" *ngIf="recordData?.content" [innerHtml]="recordData?.content | safeDom">
				</div>
			</ng-container>
		</div>
		<div class="btn-block" fxLayout="column" fxLayoutAlign="start stretch"
			*ngIf="recordData?.icon || recordData?.action?.length">
			<div class="row" fxLayoutAlign="start start" fxLayoutGap="10px">
				<div fxLayoutAlign="start start" fxFlex="1 1 25" *ngIf="recordData?.icon">
					<mat-icon class="tick-icon">{{recordData?.icon}}</mat-icon>
				</div>
				<div fxFlex="1 1 45" fxLayoutAlign="center center" *ngIf="recordData?.action?.length">
					<!-- <button class="sub-action-btn" mat-stroked-button>continue</button> -->
					<ng-container *ngFor="let action of recordData?.action">
						<ng-container [ngSwitch]="action.type">
							<img class="alert-round" [ngClass]="action?.classes" *ngSwitchCase="'image'" [src]="action?.url"
								[matTooltip]="action?.toolTip" [class]="action?.classes" (click)="actionClick(action)">
							<ng-container *ngSwitchCase="'icon'">
								<mat-icon [matTooltip]="action?.toolTip" [ngClass]="action?.classes"
									*ngIf="![null, undefined, ''].includes(action?.icon)" (click)="actionClick(action)">
									{{action?.icon}}
								</mat-icon>
								<mat-icon [matTooltip]="action?.toolTip" [ngClass]="action?.classes"
									*ngIf="[null, undefined, ''].includes(recordData?.icon)" [svgIcon]="action?.svgIcon"
									(click)="actionClick(action)"></mat-icon>
							</ng-container>
							<button *ngSwitchCase="'iconButton'" [matTooltip]="action?.toolTip" mat-icon-button type="button"
								[ngClass]="action?.classes" (click)="actionClick(action)">
								<mat-icon>{{action?.icon}}</mat-icon>
							</button>
							<button *ngSwitchCase="'raisedButton'" class="sub-action-btn" mat-raised-button
								[matTooltip]="action?.toolTip" type="button" [ngClass]="action?.classes" (click)="actionClick(action)">
								{{action?.caption}}
							</button>
							<button *ngSwitchCase="'strokedButton'" class="sub-action-btn" mat-stroked-button
								[matTooltip]="action?.toolTip" type="button" [ngClass]="action?.classes" (click)="actionClick(action)">
								{{action?.caption}}
							</button>
							<button *ngSwitchCase="'flatButton'" class="sub-action-btn" mat-flat-button [matTooltip]="action?.toolTip"
								type="button" [ngClass]="action?.classes" (click)="actionClick(action)">
								{{action?.caption}}
							</button>
							<button *ngSwitchCase="'fabButton'" class="sub-action-btn" mat-fab [matTooltip]="action?.toolTip"
								type="button" [ngClass]="action?.classes" (click)="actionClick(action)">
								{{action?.caption}}
							</button>
							<button *ngSwitchCase="'miniFabButton'" class="sub-action-btn" mat-mini-fab [matTooltip]="action?.toolTip"
								type="button" [ngClass]="action?.classes" (click)="actionClick(action)">
								{{action?.caption}}
							</button>
							<a *ngSwitchCase="'link'" [ngClass]="action?.classes"
								(click)="actionClick(action)">{{action?.caption}}</a>
						</ng-container>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
	<!-- ------------------Loader start shimmer------------------------ -->
	<!----<div fxLayout="column" fxLayoutAlign="center center" class="overlay-shimmer">
        <div fxLayout="column" class="wrapper">-->

	<!-- <div class="thumbnail-circle animate"></div>  -->
	<!---- <div fxLayout="row">
                    <div fxFlex="1 0">
                        <div class="thumbnail animate-thumb"></div>
                    </div>

                    <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px" fxFlex="1 0">
                        <div class="comment-line animate-line"></div>
                        <div class="comment-line animate-line"></div>
                    </div>
                </div>


                <div fxLayout="column" fxLayoutGap="5px">
                  <div>
                    <div class="comment-line animate-thumb" fxFlex="70%"></div>
                  </div>
                  <div>
                    <div class="comment-line animate-thumb" fxFlex="100%"></div>
                  </div>
                  <div>
                    <div class="comment-line animate-thumb" fxFlex="100%"></div>
                  </div>
              </div>
        </div>
    </div>--->
	<!-- ------------------Loader end------------------------ -->
</div>

<div class="task-card-block" *ngIf="recordData && recordData?.type === 'type-2'" [ngClass]="recordData?.classes">
	<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
		<div class="main-content" fxFlex="1 0 auto">

			<div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px">
				<!-- <div fxLayoutAlign="center center" class="round"></div> -->
				<img *ngIf="recordData?.thumbnail" [src]="recordData?.thumbnail" alt="" fxLayoutAlign="start center"
					class="assignee-dtls">
				<div class="content-block" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px"
					*ngIf="recordData?.assignedby || recordData?.title || recordData?.submittedOn || recordData?.notice">

					<ng-container *ngIf="recordData?.assignedby">
						<div>
							<div class="sub-text-1">{{ locale.translate('assigned_by')}}</div>
							<span class="sub-caption-1">{{recordData?.assignedby}}</span>
						</div>
					</ng-container>

					<ng-container *ngIf="recordData?.title">
						<span class="entity-title">{{recordData?.title}}
						</span>
					</ng-container>

					<ng-container *ngIf="recordData?.submittedOn">
						<div>
							<div class="sub-caption-1">{{ locale.translate('submit_by')}}</div>
							<span class="sub-text-1">{{recordData?.submittedOn}}
							</span>
						</div>
					</ng-container>
					<!-- <div class="icon-txt" fxLayout="row" *ngIf="recordData?.notice">
                        <mat-icon class="icon-design">{{recordData?.notice?.icon}}</mat-icon>
                        <div class="color-size-change" *ngIf="recordData?.notice?.content"
                            [innerHtml]="recordData?.notice?.content | safeDom">
                        </div>
                    </div> -->
				</div>
			</div>
		</div>
		<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" *ngIf="recordData?.action?.length">
			<!-- <div class="btn-containter" fxLayoutAlign="center end"> -->
			<ng-container *ngFor="let action of recordData?.action">
				<ng-container [ngSwitch]="action.type">
					<img class="alert-round" [ngClass]="action?.classes" *ngSwitchCase="'image'" [src]="action?.url"
						[matTooltip]="action?.toolTip" [class]="action?.classes" (click)="actionClick(action)">
					<ng-container *ngSwitchCase="'icon'">
						<mat-icon [matTooltip]="action?.toolTip" [ngClass]="action?.classes"
							*ngIf="![null, undefined, ''].includes(action?.icon)" (click)="actionClick(action)">
							{{action?.icon}}
						</mat-icon>
						<mat-icon [matTooltip]="action?.toolTip" [ngClass]="action?.classes"
							*ngIf="[null, undefined, ''].includes(recordData?.icon)" [svgIcon]="action?.svgIcon"
							(click)="actionClick(action)"></mat-icon>
					</ng-container>
					<button *ngSwitchCase="'iconButton'" [matTooltip]="action?.toolTip" mat-icon-button type="button"
						[ngClass]="action?.classes" (click)="actionClick(action)">
						<mat-icon>{{action?.icon}}</mat-icon>
					</button>
					<button *ngSwitchCase="'raisedButton'" class="sub-action-btn" mat-raised-button [matTooltip]="action?.toolTip"
						type="button" [ngClass]="action?.classes" (click)="actionClick(action)">
						{{action?.caption}}
					</button>
					<button *ngSwitchCase="'strokedButton'" class="sub-action-btn" mat-stroked-button
						[matTooltip]="action?.toolTip" type="button" [ngClass]="action?.classes" (click)="actionClick(action)">
						{{action?.caption}}
					</button>
					<button *ngSwitchCase="'flatButton'" class="sub-action-btn" mat-flat-button [matTooltip]="action?.toolTip"
						type="button" [ngClass]="action?.classes" (click)="actionClick(action)">
						{{action?.caption}}
					</button>
					<button *ngSwitchCase="'fabButton'" class="sub-action-btn" mat-fab [matTooltip]="action?.toolTip"
						type="button" [ngClass]="action?.classes" (click)="actionClick(action)">
						{{action?.caption}}
					</button>
					<button *ngSwitchCase="'miniFabButton'" class="sub-action-btn" mat-mini-fab [matTooltip]="action?.toolTip"
						type="button" [ngClass]="action?.classes" (click)="actionClick(action)">
						{{action?.caption}}
					</button>
					<a *ngSwitchCase="'link'" [ngClass]="action?.classes" (click)="actionClick(action)">{{action?.caption}}</a>
				</ng-container>
			</ng-container>
			<!-- </div> -->
		</div>
	</div>

	<!-- ------------------Loader start shimmer------------------------ -->
	<!-- <div fxLayout="column" fxLayoutAlign="center center" class="overlay-shimmer">
        <div fxLayout="column" class="wrapper">

          <div class="thumbnail-circle animate-thumb"></div>



                <div fxLayout="column" fxLayoutGap="5px">
                  <div>
                    <div class="comment-line animate-thumb" fxFlex="50%"></div>
                  </div>
                  <div>
                    <div class="comment-line animate-thumb" fxFlex="80%"></div>
                  </div>
                  <div>
                    <div class="comment-line animate-thumb" fxFlex="100%"></div>
                  </div>
              </div>
        </div>
      </div> -->
	<!-- ------------------Loader end------------------------ -->
</div>
